import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const styles = {
  gold: "bg-champagne text-[#050505] hover:bg-champagne-light hover:shadow-[0_10px_40px_rgba(177,138,68,0.28)]",
  outline:
    "border border-[rgba(200,164,93,0.45)] text-ivory hover:border-champagne hover:bg-champagne hover:text-[#050505]",
  text: "px-0 text-ivory hover:text-champagne",
};

export const LuxButton = ({
  children,
  variant = "gold",
  to,
  onClick,
  arrow = false,
  className = "",
  type = "button",
  testId,
  disabled = false,
}) => {
  const handleMove = (e) => {
    if (
      !window.matchMedia("(pointer: fine)").matches ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    )
      return;
    const el = e.currentTarget;
    const r = el.getBoundingClientRect();
    const dx = Math.max(-4, Math.min(4, ((e.clientX - (r.left + r.width / 2)) / r.width) * 8));
    const dy = Math.max(-3, Math.min(3, ((e.clientY - (r.top + r.height / 2)) / r.height) * 6));
    el.style.setProperty("--mx", `${dx.toFixed(1)}px`);
    el.style.setProperty("--my", `${dy.toFixed(1)}px`);
  };
  const reset = (e) => {
    e.currentTarget.style.setProperty("--mx", "0px");
    e.currentTarget.style.setProperty("--my", "0px");
  };
  const cls = `group relative inline-flex select-none items-center justify-center px-9 py-[15px] text-[11px] font-medium uppercase tracking-[0.26em] transition-[background-color,color,border-color,box-shadow] duration-[350ms] ease-[cubic-bezier(0.22,1,0.36,1)] disabled:opacity-50 ${styles[variant]} ${className}`;
  const inner = (
    <span className="inline-flex items-center gap-3 transition-transform duration-300 ease-out [transform:translate(var(--mx,0px),var(--my,0px))]">
      {children}
      {arrow && (
        <ArrowRight
          className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-[5px]"
          strokeWidth={1.5}
        />
      )}
    </span>
  );
  if (to) {
    return (
      <Link
        to={to}
        data-testid={testId}
        className={cls}
        onMouseMove={handleMove}
        onMouseLeave={reset}
        onClick={onClick}
      >
        {inner}
      </Link>
    );
  }
  return (
    <button
      type={type}
      data-testid={testId}
      className={cls}
      onMouseMove={handleMove}
      onMouseLeave={reset}
      onClick={onClick}
      disabled={disabled}
    >
      {inner}
    </button>
  );
};
